import { DSButton, DSTypography } from '@eiv2/design-system';

export interface RequestStateProps {
  title: string;
  message?: string;
  error?: string | null;
  onRetry?: () => void;
}

export function RequestState({ title, message, error, onRetry }: RequestStateProps) {
  if (error) {
    return (
      <div
        className="flex flex-col gap-3 rounded-3xl border border-feedback-danger/30 bg-body-light-mode-1 p-4 sm:flex-row sm:items-center sm:justify-between"
        role="alert"
      >
        <div className="min-w-0">
          <DSTypography as="p" className="text-[14px] font-semibold text-feedback-danger">
            {title}
          </DSTypography>
          <DSTypography as="p" className="mt-1 text-[13px] font-normal text-dark-3">
            {error}
          </DSTypography>
        </div>
        {onRetry ? (
          <DSButton className="w-auto shrink-0" onClick={onRetry} type="button" variant="secondary">
            Tentar novamente
          </DSButton>
        ) : null}
      </div>
    );
  }

  return (
    <div
      aria-busy="true"
      aria-live="polite"
      className="flex min-h-[calc(100dvh-14rem)] w-full flex-col items-center justify-center gap-3 px-4 py-8 text-center"
    >
      <span
        aria-hidden
        className="size-8 animate-spin rounded-full border-2 border-gray-3 border-t-brand-primary-3"
      />
      <div className="max-w-md">
        <DSTypography as="p" className="text-[15px] font-semibold text-dark-3">
          {title}
        </DSTypography>
        {message ? (
          <DSTypography as="p" className="mt-1 text-[13px] font-normal text-gray-5">
            {message}
          </DSTypography>
        ) : null}
      </div>
    </div>
  );
}
